"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const expertsSlice_1 = require("../../../../../redux/slices/expertsSlice");
require("./areas.scss");
const react_redux_1 = require("react-redux");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const filter_1 = __importDefault(require("lodash/filter"));
const Areas = (props) => {
    const { filters, directoryType } = props.props;
    const { getExperts, getServiceExperts, areasList = [], expertId, experts } = props;
    const requestType = directoryType === 'serviceExperts' ? getServiceExperts : getExperts;
    const changedFilters = cloneDeep_1.default(Object.assign(Object.assign({}, filters), { offset: 0 }));
    const handleClick = (item) => {
        let items = [];
        if (directoryType == 'experts') {
            items = filter_1.default(experts.areas, { subCategories: [{ id: item.id }] })
                .map(v => ({ id: item.id, name: item.name, parent_id: v.id }));
        }
        else {
            items = filter_1.default(experts.mergeServices, { id: item.lang_id || item.id, parent_id: item.service_id });
        }
        changedFilters['selectedFilters'] = items;
        requestType(changedFilters);
    };
    let areas = areasList === null || areasList === void 0 ? void 0 : areasList.slice(0, 3);
    areas = areas === null || areas === void 0 ? void 0 : areas.map((area, key) => react_1.default.createElement("div", { key: key, className: "area", onClick: () => handleClick(area) }, area.name));
    return (react_1.default.createElement(core_1.Box, { id: 'areas-of-expertise', className: "v2-container-background areas-box" },
        react_1.default.createElement("div", { className: "areas" },
            areas,
            (areasList === null || areasList === void 0 ? void 0 : areasList.length) > 3 && react_1.default.createElement("div", { className: "area" },
                react_1.default.createElement("a", { target: '_blank', href: `#/directory/${directoryType == 'experts' ? 'expertsProfile' : 'servicesProfile'}?uid=${expertId}`, className: "link" }, "...")))));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getExperts: (data) => dispatch(expertsSlice_1.getExperts(data)),
        getServiceExperts: (data) => dispatch(expertsSlice_1.getServiceExperts(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Areas);
